class CustomStickyATC {
  constructor() {
    this.stickyATC = document.getElementById('customStickyAtc');
    this.productForm = document.querySelector('.product-form');
    this.buyButtons = document.querySelector('.product__buy_buttons');
    this.quantityInput = null;
    this.atcButton = null;
    this.quantityButtons = null;
    this.isProcessing = false;

    if (this.stickyATC) {
      this.init();
    }
  }

  init() {
    this.setupElements();
    this.setupScrollHandler();
    this.setupQuantityHandlers();
    this.setupATCHandler();

    this.setupVariantHandler();
    this.setupFormSubmissionListener();
  }

  setupElements() {
    this.quantityInput = this.stickyATC.querySelector('.quantity__input');
    this.atcButton = this.stickyATC.querySelector('.custom-sticky-atc__button');
    this.quantityButtons = this.stickyATC.querySelectorAll('.quantity__button');
  }

  setupScrollHandler() {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateStickyATC = () => {
      const scrollY = window.scrollY;
      const buyButtonsRect = this.buyButtons?.getBoundingClientRect();

      if (buyButtonsRect) {
        const isOutOfView = buyButtonsRect.bottom < 0 || buyButtonsRect.top > window.innerHeight;

        if (isOutOfView && scrollY > 200) {
          this.stickyATC.classList.add('active');
        } else {
          this.stickyATC.classList.remove('active');
        }
      }

      lastScrollY = scrollY;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateStickyATC);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  setupQuantityHandlers() {
    this.setupTwoWayQuantitySync();
  }

  setupTwoWayQuantitySync() {
    const mainQty = document.querySelector('input[name="quantity"]');
    const stickyQty = document.querySelector('input[name="sticky-quantity"]');

    if (!mainQty || !stickyQty) return;

    const syncMinusButtons = () => {
      const value = parseInt(mainQty.value) || 1;
      const mainMinusBtn = document.querySelector('input[name="quantity"]').closest('quantity-input')?.querySelector('button[name="minus"]');
      const stickyMinusBtn = document.querySelector('input[name="sticky-quantity"]').closest('quantity-input')?.querySelector('button[name="minus"]');

      if (value <= 1) {
        mainMinusBtn?.classList.add("disabled");
        stickyMinusBtn?.classList.add("disabled");
      } else {
        mainMinusBtn?.classList.remove("disabled");
        stickyMinusBtn?.classList.remove("disabled");
      }
    };

    mainQty.addEventListener('input', () => {
      stickyQty.value = mainQty.value;
      syncMinusButtons();
    });

    mainQty.closest('quantity-input')?.addEventListener('change', () => {
      stickyQty.value = mainQty.value;
      syncMinusButtons();
    });

    stickyQty.addEventListener('input', () => {
      mainQty.value = stickyQty.value;
      syncMinusButtons();
    });

    stickyQty.closest('quantity-input')?.addEventListener('change', () => {
      mainQty.value = stickyQty.value;
      syncMinusButtons();
    });

    syncMinusButtons();
  }

  setupATCHandler() {
    if (!this.atcButton) return;

    this.atcButton.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.isProcessing) return;
      this.isProcessing = true;

      const mainProductForm = document.querySelector('.product-form__buttons .product-form__submit');
      if (mainATCButton) {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        mainATCButton.dispatchEvent(clickEvent);
      }

      setTimeout(() => {
        this.isProcessing = false;
      }, 1000);
    });
  }

  setupFormSubmissionListener() {
    const mainProductForm = document.querySelector('.product-form__buttons .product-form__submit');
    if (mainProductForm) {
      mainProductForm.addEventListener('submit', () => {
        setTimeout(() => {
          this.isProcessing = false;
        }, 500);
      });
    }
  }

  setupVariantHandler() {
    const variantSelects = document.querySelector('variant-selects, variant-radios');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        this.updateVariantInfo();
      });
    }

    document.addEventListener('variant:change', () => {
      this.updateVariantInfo();
    });

    const mainATCButton = document.querySelector('.product-form .product-form__submit');
    if (mainATCButton) {
      const observer = new MutationObserver(() => {
        this.updateVariantInfo();
      });

      observer.observe(mainATCButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
    }
  }

  updateVariantInfo() {
    if (!this.atcButton) return;

    const mainATCButton = document.querySelector('.product-form .product-form__submit');

    if (mainATCButton) {
      this.atcButton.disabled = mainATCButton.disabled;
      this.atcButton.innerHTML = mainATCButton.innerHTML;
    }

    this.updatePrice();
    this.updateProductImage();
  }

  updatePrice() {
    const mainPrice = document.querySelector('.price--product');
    const stickyPrice = this.stickyATC.querySelector('.custom-sticky-atc__price');

    if (mainPrice && stickyPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
  }

  updateProductImage() {
    const mainImage = document.querySelector('.product__media-item:first-child img');
    const stickyImage = this.stickyATC.querySelector('.custom-sticky-atc__img');

    if (mainImage && stickyImage && mainImage.src !== stickyImage.src) {
      stickyImage.src = mainImage.src;
      stickyImage.srcset = mainImage.srcset;
      stickyImage.alt = mainImage.alt;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomStickyATC();
});

document.addEventListener('shopify:section:load', () => {
  new CustomStickyATC();
});